<template>
  <v-app id="backGND">
    <v-overlay :value="loading" z-index="10" opacity="0.88">
      <div class="loader-card">
        <v-progress-circular indeterminate size="52" width="3" color="white"></v-progress-circular>
        <div class="loader-title">Cargando Video</div>
        <div class="loader-subtitle">Verificando acceso...</div>
      </div>
    </v-overlay>
    <div v-if="flag_access" id="Videos">
      <navBar style="padding-bot: 5rem" />
      <v-row>
        <v-col elevation="20" id="videoCol" color="#55555" cols="12" md="8">
          <videoV v-if="flag_player" :src2="url"></videoV>
          <v-card v-else color="rgba(255,0,0,0)">
            <div class="embed-container embed-containervideo">
              <youtube
                class="embed-container2"
                :video-id="videoId"
                player-width="1080"
                player-height="720"
                @playing="playing"
                @ended="ended"
                @paused="paused"
                :player-vars="{ autoplay: 1, modestbranding: 0 }"
              ></youtube>
            </div>
          </v-card>
        </v-col>
        <v-col id="descCol" cols="12" md="4">
          <descV
            :vName="nameVideo"
            :vDescription="descriptionVideo"
            :vIdFirabse="videoIDFirebase"
            style="margin: auto"
          ></descV>
        </v-col>
        <v-row id="commentsRow">
          <v-col id="commentsCol" cols="12" md="11">
            <commV
            :comments="comments"
              style="margin: auto"
            ></commV>
          </v-col>
        </v-row>
      </v-row>
    </div>
  </v-app>
</template>
<script>
import navBar from "@/components/navbar";
import videoV from "@/components/video_components/player";
import descV from "@/components/video_components/description";
import commV from "@/components/video_components/comments";
import { db } from "@/main";
import { getIdFromURL, getTimeFromURL } from "vue-youtube-embed";
export default {
  components: { navBar, videoV, descV, commV },
  data() {
    return {
      loading: true,
      flag_access: false,
      url: "",
      nameVideo: "",
      descriptionVideo: "",
      videoId: "",
      flag_player: null,
      videoIDFirebase: "",
      comments: [],
    };
  },
  methods: {
    videoChange() {
      let h = this.parts.indexOf(this.videoPart);
      this.videoId = this.videos_array[h];
    },
    ready(event) {
      this.player = event.target;
    },
    playing(event) {
      console.log("Reproduciendo...");
    },
    paused(event) {
      console.log("pausado...");
    },
    ended(event) {
      console.log("terminado...");
    },
    change() {
      // when you change the value, the player will also change.
      // If you would like to change `playerVars`, please change it before you change `videoId`.
      // If `playerVars.autoplay` is 1, `loadVideoById` will be called.
      // If `playerVars.autoplay` is 0, `cueVideoById` will be called.
      this.videoId = "another video id";
    },
    stop() {
      this.player.stopVideo();
    },
    pause() {
      this.player.pauseVideo();
    },
  },
  created: async function () {
    const user = this.$store.state.authModule.user;
    if (!user) {
      this.$router.replace({ name: "Login Page" });
      return; // loading stays true — overlay covers the page until router navigates away
    }

    const userDoc = await db.collection("users").doc(user.uid).get();
    const userData = userDoc.data();
    let hasAccess = false;

    if (userData.role === "admin") {
      hasAccess = true;
    } else if (userData.packages) {
      const end = userData.packages[userData.packages.length - 1].package_end.toDate();
      if (new Date() <= end) hasAccess = true;
    }

    if (!hasAccess) {
      this.$router.replace({ name: "Precio" });
      return; // loading stays true — no content flash before redirect
    }

    this.flag_access = true;
    try {
      this.videoId = "";
      let myVideo = this.$route.params.id;
      this.videoIDFirebase = myVideo;
      await db
        .collection("videos")
        .doc(myVideo)
        .get()
        .then(async (video) => {
          video.data().video_url.includes("firebase")
            ? (this.url = video.data().video_url)
            : (this.videoId = video.data().video_url);
          video.data().video_url.includes("firebase")
            ? (this.flag_player = true)
            : (this.flag_player = false);
          this.nameVideo = video.data().video_name;
          this.descriptionVideo = video.data().description;
        });
      let videoIdd = getIdFromURL(this.videoId);
      this.videoId = videoIdd;
      await db
        .collection("videos")
        .doc(this.videoIDFirebase)
        .collection("comments")
        .orderBy("hour", "desc")
        .onSnapshot(async (commentsS) => {
          this.comments = [];
          commentsS.forEach(async (comment) => {
            await db
              .collection("users")
              .doc(comment.data().uid)
              .onSnapshot((userS) => {
                var temp = {
                  avatar: userS.data().imgUrl,
                  name: userS.data().name + " " + userS.data().lastName,
                  content: comment.data().content,
                  hour: comment.data().hour,
                  id: comment.id,
                };
                this.comments.push(temp);
              });
          });
        });
    } finally {
      this.loading = false;
    }
  },
};
</script>
<style scoped>
.videoCol {
  -webkit-box-shadow: 9px 9px 12px -1px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 9px 9px 12px -1px rgba(0, 0, 0, 0.75);
  box-shadow: 9px 9px 12px -1px rgba(0, 0, 0, 0.75);
}
@media (min-width: 768px) {
  #videoCol {
    padding: 1rem 1rem 0rem 2.5rem;
  }
  #descCol {
    padding: 1rem 0rem 0rem 0rem;
  }
  #commentsCol {
    margin: auto;
  }
}
#Videos {
  background: rgb(243, 250, 249);
  background: linear-gradient(
    90deg,
    rgba(243, 250, 249, 1) 4%,
    rgba(243, 250, 249, 1) 81%
  );
}
#backGND {
  background-image: url("../assets/back.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  margin-top: auto;
}
.embed-container {
  position: relative !important;
  padding-bottom: 60.25% !important;
  height: 0 !important;
  overflow: hidden !important;
}
.embed-container2 {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
}
.embed-containervideo {
  position: relative !important;
  padding-bottom: 60.22% !important;
  height: 0 !important;
  overflow: hidden !important;
}
.loader-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 2.5rem 3.5rem;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}
.loader-title {
  font-family: 'Poiret One', sans-serif;
  font-size: 1.5rem;
  color: white;
  letter-spacing: 0.1em;
  margin-top: 0.25rem;
}
.loader-subtitle {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.55);
  letter-spacing: 0.12em;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/videopage.vue